import { FC, useCallback, useEffect, useState } from "react";
import LoadingAnimation from "../../../components/_common/Loading";
import Marquee from "react-fast-marquee";
import { IProducer } from "../../../interfaces/IProducer";
import producersController from "../../../Api/producersController";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { baseURL } from "../../../config";

const BASE_URL = baseURL;

const Image = styled.img`
    height: 100px;
    max-width: 200px;
    object-fit: contain;
    margin-left: 40px;
    cursor: pointer;
`

interface producersSliderProps {

}

const slogans = [
    "Polscy producenci, którym warto zaufać",
    "Meble od sprawdzonych, rodzimych marek",
    "Wspieramy polskie rzemiosło meblarskie",
    "Z dumą prezentujemy polskich producentów",
    "Meble z Polski – jakość i tradycja",
    "Najlepsze marki z polskiego rynku",
    "Od polskich producentów – dla Twojego domu",
    "Solidność i styl prosto z Polski",
    "Sprawdzone marki znad Wisły",
    "Polska jakość, którą widać na pierwszy rzut oka",
    "Polskie marki, które tworzą Twoje wnętrza",
    "Z polskich fabryk – prosto do Twojego domu",
    "Tworzymy wnętrza razem z polskimi producentami",
    "Polscy producenci – nasza jakość, Twój komfort"
];

const ProducersSlider: FC<producersSliderProps> = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [producers, setProducers] = useState<IProducer[] | null>([]);
    const [slogan] = useState(() => slogans[Math.floor(Math.random() * slogans.length)]);


    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    const getProducers = useCallback(async () => {
        setLoading(true);
        const res = await producersController.getAllProducers();
        if (res.ok && res.producers) {
            const filteredProducers = res.producers.filter(
                (producer: IProducer) => !["signal", "Dodaj kolejną"].includes(producer.name.toLowerCase())
            );
            const shuffledProducers = shuffleArray(filteredProducers);
            setProducers(shuffledProducers)
        }
        setLoading(false);
    }, [
        setLoading
    ])

    useEffect(() => {
        getProducers()
    }, [getProducers])

    if (loading) return <LoadingAnimation />

    if (!producers || producers.length === 0) return <></>

    return (
        <>
            <Typography
                variant="subtitle1"
                sx={{
                    textAlign: 'center',
                    marginTop: '76px',
                    marginBottom: '40px',
                    fontWeight: 400,
                    letterSpacing: 0.5,
                    fontFamily: 'Montserrat, Roboto, Arial, sans-serif',
                    color: '#222',
                    opacity: 0.85,
                    fontSize: { xs: '0.95rem', sm: '1.1rem', md: '1.2rem' },
                    lineHeight: 1.6,
                }}
            >
                {slogan}
            </Typography>
            <Marquee
                gradient={window.innerWidth >= 940}
                pauseOnHover
            >
                {producers.map((producer, index) => (
                    <Image
                        src={`${BASE_URL}${producer.logo.replace("producersImages/", "producersImages/thumbnailProducersImages/")}`}
                        alt={producer.name}
                        key={index}
                        onClick={() => {
                            if (producer.link) {
                                window.location.href = producer.link;
                            }
                        }}
                    />
                ))}
            </Marquee>
        </>
    )
}

export default ProducersSlider;